const ShipmentDetailType = {
    forecast: 'forecast',
    amazon: 'amazon',
    forecastValid: 'forecast-valid',
    forecastChosen: 'forecast-chosen'
};

module.exports = Object.freeze(ShipmentDetailType);